// import { Separator } from "@/components/atoms/divider/separator";
import ListOfEditableOverview from "@/components/organisms/ListOfEditableOverview";
import { useState, useEffect, useMemo } from "react";
import Filter from "@/components/organisms/Filter";
import { useAuthContext } from '@/context/AuthContext';
import useConsultantStatementYears from "@/services/admin-services/query/useConsultantStatementYears";
import useConsultantStatement from "@/services/admin-services/query/useConsultantStatement";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import SkeletonHandler from "@/components/templates/skeletons/SkeletonHandler";
import { Toaster } from "@/components/organisms/feedback/toaster";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import { Label } from "@/components/atoms/texts/label";
import { useParams } from "react-router-dom";
import PrintEmptyDataMessage from "@/components/molecules/PrintEmptyDataMessage";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import InvoicesTab from "./InvoicesTab";
import { Button } from "@/components/molecules/buttons/button";
import { Paid } from '@mui/icons-material';
import { Separator } from "@/components/atoms/divider/separatorShadcn";
import StatementTable from "@/components/organisms/StatementTable";
import StatementOperationsChart from "@/components/organisms/charts/StatementOperationsChart";
import {useAppSelector} from '@/store/hooks.js';

export default function StatementTab() {
    const { id } = useParams();
    const { hasPrivileges } = useAuthContext();
    const user = useAppSelector((state) => state.auth.currentUser);
    
    // ✅ Calculer l'année par défaut : la plus récente disponible
    const { allYears, errorYear } = useConsultantStatementYears(id);
    
    const defaultYear = useMemo(() => {
        if (!allYears || allYears.length === 0) return null;
        
        // Trier par ordre décroissant et prendre la plus récente
        const sortedYearsDesc = [...allYears].sort((a, b) => b - a);
        return sortedYearsDesc[0]; // Année la plus récente
    }, [allYears]);
    
    const [selectedYear, setSelectedYear] = useState(null);
    const [invoicesTab, setInvoiceTab] = useState(false);

    // ✅ Synchroniser selectedYear avec allYears et gérer la persistance
    useEffect(() => {
        if (!allYears || allYears.length === 0) return;
        
        // Si selectedYear existe déjà ET est toujours dans allYears
        if (selectedYear && allYears.includes(selectedYear)) {
            return; // Persistance de l'année lors du changement de consultant
        }
        
        // Sinon on initialise avec l'année par défaut
        if (defaultYear) {
            setSelectedYear(defaultYear);
        }
    }, [allYears, defaultYear, id]); // id ajouté pour détecter le changement de consultant

    // ✅ Skip la requête tant que selectedYear n'est pas défini
    const { error, loading, data: yearData} = useConsultantStatement(selectedYear, id, !selectedYear);
    // const [allYearlyData, setAllYearlyData] = useState([]);
    // const [yearData, setYearData] = useState({});

    // //faire une requête pour chaque années disponible dans allYears
    // useEffect(() => {
    //     if (id && allYears) {
    //         const fetchData = async () => {
    //             const data = [];
    //             for (const year of allYears) {
    //                 const result = await getAllStatamentData(user.strongToken, year, id);
    //                 if (result.data) {
    //                     data.push(result.data);
    //                 }
    //             }
    //             setAllYearlyData(data);
    //         };
    //         fetchData();
    //     }
    // }, [id, allYears]);

    // useEffect(() => {
    //     // Sélectionner les données de l'année cliquée
    //     if (allYearlyData) {
    //         const selectedData = allYearlyData.find(
    //             (item) => item.year === parseInt(selectedYear)
    //         );
    //         // console.log("selected data", selectedData);
    //         setYearData(selectedData);
    //     }
    // }, [selectedYear, allYearlyData]);

    if (!allYears) {
        return (
            <div className="grid grid-cols-2">
                <SkeletonHandler name={"overview"} />
                <SkeletonHandler name={"overflow"} />
            </div>
        );
    }

    if (id == "undefined")
        return (
            <PrintEmptyDataMessage
                message={"error.selectUser"}
                icon={<AdsClickIcon />}
            />
        );

    if (error) {
        console.log("Statement Tab error : ", error);
        <PrintErrorMessage message={error} />;
    }

    return (
        !invoicesTab ?
            <div className="h-[100%] w-[100%] flex flex-col gap-1 statementTab ">


                {allYears?.length > 0 && <div className="flex flex-row w-full justify-end h-[47px]">
                    <div className="ml-auto flex items-center justify-center w-full  space-x-4">
                        <Filter
                            items={allYears && allYears}
                            informSelectedItem={setSelectedYear}
                            defaultSelectedItem={selectedYear || defaultYear}
                            sortItemDESC={true}
                        />

                    </div>
                    {hasPrivileges("ADMIN_INVOICE") && <Button onClick={() => setInvoiceTab(true)} leftIcon={<Paid />} showLeftIcon text="consultants.statement.overflow.seeBillsDetails" />}
                </div>}

                {allYears?.length == 0 ? (
                    <PrintEmptyDataMessage
                        message={"error.emptyData"}
                        icon={<WarningAmberRoundedIcon />}
                    />
                ) : error ? (
                    <PrintErrorMessage error={error} />
                ) : (
                    <div className=" flex  gap-secondDegree ">
                        <div className=" w-[300px] flex flex-col gap-firstDegree  ">
                            <div className="flex items-center justify-start gap-firstDegree">
                                <Label
                                    size="h3"
                                    fontWeight="bold"
                                    message="consultants.statement.overview.overview"
                                />
                                {loading && <span className="loader" />}
                            </div>

                            <ListOfEditableOverview
                                year={selectedYear}
                                yearData={yearData}
                                userActive={user}
                            />
                        </div>

                        <Separator orientation="vertical" />

                        <div className="grow  flex flex-col gap-thirdDegree">
                            <div className="flex flex-col items-start w-full gap-secondDegree">
                                <Label
                                    size="h3"
                                    fontWeight="bold"
                                message="consultants.statement.overflow.recap"
                                ></Label>
                                {loading && <span className="loader" />}
                                {error && <PrintErrorMessage message={error} />}
                                <StatementTable data={yearData} dataOwner/>

                            </div>

                            {/* <TableOverflow yearData={yearData} /> */}

                            {hasPrivileges("ADMIN_STATEMENT") && selectedYear &&<div className="flex flex-col items-start w-full gap-thirdDegree">
                                <Label
                                    size="h3"
                                    fontWeight="bold"
                                    message="consultants.statement.overflow.overflowFluctuation"
                                />
                                 <StatementOperationsChart year={selectedYear} yearStatement={yearData} dataOwner/>

                            </div>}
                            {/* inserer ici le graph  */}

                            {/* <div className="w-[100%]  max-h-[250px] h-full  bg-lighter"> */}
                            {/* <LineChartComp yearData={yearData} /> */}
                            {/* </div> */}
                        </div>
                    </div>
                )}

                <Toaster />
            </div>

            :
            <InvoicesTab setInvoiceTab={setInvoiceTab} allYears={allYears} selectedYearParent={selectedYear} dataOwner={hasPrivileges("ADMIN_INVOICE")}/>
    );
}
